import { useEffect, useState } from 'react';

import { NotifyUseCaseInterface } from 'application/usecases/NotifyUseCase';
import { NotifyData, ParamsNotify } from 'domain/entities/NotifyEntity';
import { openErrorNoti } from 'presentation/components/Notification';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { reCountNotify } from 'presentation/redux/features/counter/notifyCounterSlice';
import { RootState } from 'presentation/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import NotifyList from '../components/NotifyList';
interface props {
    notifyUseCase: NotifyUseCaseInterface;
}

const Tab1Component = ({ notifyUseCase }: props) => {
    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [total, setTotal] = useState<number>(0);
    const [listNotify, setListNotify] = useState<NotifyData[]>([]);
    const notifyCounterSlice = useSelector((state: RootState) => state.notifyCounterSlice);
    const [init, setInit] = useState<boolean>(true);

    useEffect(() => {
        getListNotify({ page: page, pageSize: 12 });
    }, [page]);

    useEffect(() => {
        if (notifyCounterSlice.reCount && !init) {
            const pageSize = listNotify.length + notifyCounterSlice.value;
            getListNotify({ page: 1, pageSize: pageSize });
            dispatch(reCountNotify());
        }
    }, [notifyCounterSlice.reCount, init]);

    const getListNotify = async (params: ParamsNotify) => {
        try {
            dispatch(startFetching());
            const response = await notifyUseCase.getListNotify(params);
            setTotal(response?.data?.total ?? 0);
            const listNotifyNew = response?.data?.notifications ?? [];
            if (params.page === 1) setListNotify(listNotifyNew);
            else {
                setListNotify([...listNotify, ...listNotifyNew]);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
            if (init) {
                setInit(false);
            }
        }
    };
    const putNotice = async (id: number) => {
        try {
            dispatch(startFetching());
            const response: any = await notifyUseCase.updateOperationNotice({ id: id });
            if (response) {
                const newListNotify = listNotify.map((item: NotifyData) => {
                    if (item.id === id) {
                        return {
                            ...item,
                            alreadyRead: 1,
                        } as NotifyData;
                    }
                    return item;
                });
                setListNotify(newListNotify);
                dispatch(reCountNotify());
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };
    const handleScroll = async (e: any) => {
        if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
            if (total && total > listNotify.length) {
                setPage((prev) => prev + 1);
            }
        }
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
                textAlign: 'center',
            }}
        >
            <NotifyList handleScroll={handleScroll} listNotify={listNotify} putNotice={putNotice} />
        </div>
    );
};

export default Tab1Component;
